export const GLOBAL_MODAL_STYLE_VALUE = {
  PADDING_X: 3.5,
};
